import { render } from "./MediaDetailsPage.vue?vue&type=template&id=151674b2&scoped=true"
import script from "./MediaDetailsPage.vue?vue&type=script&lang=js"
export * from "./MediaDetailsPage.vue?vue&type=script&lang=js"

import "./MediaDetailsPage.vue?vue&type=style&index=0&id=151674b2&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151674b2"]])

export default __exports__